module.exports = __webpack_public_path__ + "462022e551adf1fce88404f8d8f2c350.svg";